import api from './api'
import Cookies from "js-cookie";


export async function getOrders() {
    const res = await api.get('/api/orders', {
        headers: {
            'Authorization': `Bearer ${Cookies.get('token')}`
        }
    })
    // console.log(res)
    return res.data
}

export async function createOrder(order) {
    await api.post('/api/orders', order, {
        headers: {
            'Authorization': `Bearer ${Cookies.get('token')}`
        }
    })
}

export async function updateOrder(id, order) {
    await api.put('/api/orders/' + id, order, {
        headers: {
            'Authorization': `Bearer ${Cookies.get('token')}`
        }
    })
}

export async function serveItem(orderId, itemId) {
    const url = '/api/orders/' + orderId + '/items/' + itemId + '/serve';
    const res = await api.get(url, {
        headers: {
            'Authorization': `Bearer ${Cookies.get('token')}`
        }
    });
    return res.data;
}

export async function paymentOrder(id, action, paymentMethod) {
    const token = Cookies.get('token')

    if (typeof action === 'object' && action !== null) {
        await api.put('/api/orders/' + id, action, {
            headers: {
                Authorization: `Bearer ${token}`
            }
        });

        const serveUrl = '/api/orders/' + id + '/payment?payment=' + (paymentMethod === 'transfer');

        await api.post(serveUrl, null, {   // 🔥 FIX
            headers: {
                Authorization: `Bearer ${token}`
            }
        });

    } else if (action === 1) {
        const url = '/api/orders/' + id + '/payment?payment=' + (paymentMethod === 'transfer');

        await api.post(url, null, {   // 🔥 FIX
            headers: {
                Authorization: `Bearer ${token}`
            }
        });
    }
}

export async function lenMon(id) {
    const url = '/api/orders/' + id + '/len-mon';
    //console.log(url)
    const res = await api.get(url, {
        headers: {
            'Authorization': `Bearer ${Cookies.get('token')}`
        }
    });
    // console.log(res)
    return res
}

export async function serveOrderItems(orderID, itemsID) {
    const url = '/api/orders/' + orderID + '/items/' + itemsID + '/serve';
    //console.log(url)
    const res = await api.get(url, {
        headers: {
            'Authorization': `Bearer ${Cookies.get('token')}`
        }
    });
    // console.log(res)
    return res.data
}

export async function getOrdersByTable(tableId) {
    const url = '/api/orders/get-by-table/' + tableId;
    //console.log(url)
    const res = await api.get(url, {
        headers: {
            'Authorization': `Bearer ${Cookies.get('token')}`
        }
    });
    //console.log(res.data)
    return res.data;
}

export async function getOrderByTable() {
    const url = '/api/orders/get-by-table';
    //console.log(url)
    const res = await api.get(url, {
        headers: {
            'Authorization': `Bearer ${Cookies.get('token')}`
        }
    });
    // console.log(res.data)
    return res.data;
}

export async function updateOrderItems(orderId, items) {
    const url = '/api/orders/' + orderId + '/items';

    const res = await api.get(url, {items}, {
        headers: {
            'Authorization': `Bearer ${Cookies.get('token')}`
        }
    });
    return res.data;
}

// New: fetch all paid orders for today
export async function getOrdersToday() {
    const url = '/api/orders/paid-today';
    //console.log('GET', url)
    const res = await api.get(url, {
        headers: {
            'Authorization': `Bearer ${Cookies.get('token')}`
        }
    });
    // console.log(res.data)
    return res.data;
}

export async function getOrderByMonth(month, year) {
    const url = '/api/orders/orders-by-month';
    //console.log('GET', url)
    const res = await api.get(url, {
                params: {
                    month: Number(month),
                    year: Number(year)
                },
                headers: {
                    'Authorization':
                        `Bearer ${Cookies.get('token')}`
                }
            }
        )
    ;
    // console.log(res.data)
    return res.data;
}

export async function deleteOrderItem(itemId) {
    const url = `/api/orders/delete/items/${itemId}`
    //console.log('GET', url)
    const res = await api.get(url, {
        headers: {
            'Authorization': `Bearer ${Cookies.get('token')}`
        }
    });
    // console.log(res.data)
    return res.data;
}

// Transfer order to a different table
export async function transferTable(orderId, newTableId) {
    const url = `/api/orders/${orderId}/transfer-table?newTableId=${newTableId}`;
    const res = await api.post(url, {}, {
        headers: {
            'Authorization': `Bearer ${Cookies.get('token')}`
        }
    });
    return res.data;
}

